const initialFields = {
  Bairro: {
    id: "",
    isFictional: false,
    field: "Bairro",
    label: "Bairro",
  },
  Cidade: {
    id: "",
    isFictional: false,
    field: "Cidade",
    label: "Cidade",
  },
  Estado: {
    id: "",
    isFictional: false,
    field: "Estado",
    label: "Estado",
  },
  Região: {
    id: "",
    isFictional: false,
    field: "Região",
    label: "Região",
  },
  País: {
    id: "",
    isFictional: false,
    field: "País",
    label: "País",
  },
  Continente: {
    id: "",
    isFictional: false,
    field: "Continente",
    label: "Continente",
  },
};

export const initialState = {
  isModalOpen: false,
  type: null,
  fields: initialFields,
  localities: null,
  selectedValue: null,
};
